import r from "react";
import t from "prop-types";
import n from "./TextInput/index.es.js";
import './DateTextInput.css';const a = "DateTextInput-module__container___J1f6T", u = {
  container: a
}, l = (e) => /* @__PURE__ */ r.createElement("div", { className: u.container }, /* @__PURE__ */ r.createElement(
  n,
  {
    label: e.label,
    placeholder: e.placeholder,
    value: e.value,
    onBlur: (o) => e.onSet(o.target.value, !0),
    onFocus: e.onFocus,
    onSubmit: (o) => e.onSet(o.target.value),
    showIcon: !0,
    showClear: !1,
    size: e.large ? 16 : 10,
    tooltipPlacement: "bottom",
    icon: {
      name: "calendar",
      disabled: !0
    },
    error: e.error,
    focused: e.focused
  }
));
l.propTypes = {
  value: t.string.isRequired,
  label: t.string.isRequired,
  placeholder: t.string.isRequired,
  onSet: t.func.isRequired,
  large: t.bool.isRequired,
  focused: t.bool.isRequired,
  error: t.string,
  onFocus: t.func
};
l.defaultProps = {
  error: null,
  onFocus: () => !0
};
export {
  l as D
};
